import { useEffect, useState } from "react";
import api from "../lib/api";
import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Switch } from "./ui/switch";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";

export default function AiCard() {
  const [c, setC] = useState(null); const [u, setU] = useState(null);
  useEffect(() => { api.get("/ai/settings").then((r) => setC(r.data)); api.get("/ai/usage").then((r) => setU(r.data)); }, []);
  if (!c) return null;
  const save = async () => { try { setC((await api.put("/ai/settings", c)).data); toast.success("Kaydedildi"); } catch (e) { toast.error(e.response?.data?.detail || "Kaydedilemedi"); } };
  const f = (k) => ({ value: c[k] ?? "", onChange: (e) => setC({ ...c, [k]: e.target.value }) });
  return (
    <Card className="p-5 shadow-none border-slate-200 space-y-3" data-testid="ai-card">
      <div className="font-semibold flex items-center gap-2"><Sparkles className="h-4 w-4" />Yapay zekâ yardımcıları</div>
      <p className="text-sm text-slate-500">Müşteri yanıt önerisi, servis notu düzeltme, parça fotoğrafı tanıma ve arama kaydı çözümleme. OpenAI veya OpenAI uyumlu herhangi bir sağlayıcının adresi/anahtarıyla çalışır. Telefon, e-posta ve uzun numaralar sağlayıcıya gönderilmeden maskelenir; yine de metinler harici sağlayıcıya gider.</p>
      <div className="flex items-center gap-2"><Switch checked={c.enabled} onCheckedChange={(v) => setC({ ...c, enabled: v })} data-testid="ai-enabled" /><Label>Açık</Label>{u && <span className="text-xs text-slate-500 ml-auto">Bugün {u.today}/{u.limit} istek</span>}</div>
      <div className="grid sm:grid-cols-2 gap-3">
        <div><Label>API adresi</Label><Input {...f("base_url")} data-testid="ai-url" /></div>
        <div><Label>API anahtarı</Label><Input type="password" {...f("api_key")} data-testid="ai-key" placeholder="sk-…" /></div>
        <div><Label>Sohbet modeli</Label><Input {...f("chat_model")} /></div><div><Label>Görsel modeli</Label><Input {...f("vision_model")} /></div>
        <div><Label>Ses→metin modeli</Label><Input {...f("transcribe_model")} /></div><div><Label>Günlük istek limiti</Label><Input type="number" value={c.daily_limit} onChange={(e) => setC({ ...c, daily_limit: Number(e.target.value) })} /></div>
      </div>
      <Button onClick={save} className="bg-blue-600 hover:bg-blue-700" data-testid="ai-save">Kaydet</Button>
      <p className="text-xs text-amber-700">Bu özellikler canlı bir sağlayıcıyla henüz denenmedi; ilk kullanımda küçük bir metinle deneyin.</p>
    </Card>
  );
}
